import React from 'react';
import { Container } from 'reactstrap';

import GreenCheckList from '../../../GreenCheckList';

import consultPartner from './assets/consulting-partner.png';

const PremierPartner = () => {
  return (
    <section className="PremierPartner">
      <Container>
        <div className="PremierPartner__wrapper">
          <div className="w-lg-50 pr-lg-3">
            <h2 className="PremierPartner__title">
              Work With A&nbsp;
              <span className="text-dark-blue">Premier Partner</span>
            </h2>

            <div className="PremierPartner__lead">
              Whether you are looking to enhance business functionality or safeguard your data, we have you covered. Cloudnexa is dedicated to helping clients achieve their business and IT objectives with a range of solutions varying from cloud optimization to digital transformations.
            </div>
          </div>

          <div className="w-lg-50 pl-lg-5">
            <div className="PremierPartner__subTitle">
              
            </div>

            <GreenCheckList
              className="PremierPartner__list"
              items={[
                'Trained and certified team with over 200 AWS certifications.',
                'Long standing AWS Partner since 2008.',
                'Selected by AWS for excellence in service and expertise.',
              ]}
            />
          </div>
        </div>

        <div className="PremierPartner__card">
          <div className="PremierPartner__card__badge">
            <img src={consultPartner} alt="AWS consulting partner" />
          </div>

          <div className="PremierPartner__card__details">
            <h3 className="PremierPartner__card__title">
              <span className="text-blue">AWS</span> Premier Consulting Partner
            </h3>

            <div className="PremierPartner__card__text">
              Better your cloud experience by getting the proven expertise and valuable tools you need from an AWS Premier Partner.
            </div>

            <a href="/about" className="btn btn-outline-primary">Why Trust Cloudnexa</a>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default PremierPartner;
